'use client'

import { Settings } from 'luxon'

export default function DateSettings() {
  Settings.throwOnInvalid = true

  return null
}
